import { fetchData } from '@services/api-service';
import { ISearchMemoriesPayload } from './search-bar.typings';

export const searchMemories = async (payload: ISearchMemoriesPayload) => {
  return fetchData({ requestUrl: 'searchMemories', payload });
};
